// Only a failure of the CURRENT authenticated request can invalidate a session.
// A late 401 from a prior tab/login must not destroy a newer token.
export const shouldClearSession = (error, currentToken) => {
  if (!currentToken || error?.response?.status !== 401) return false;
  const data = error.response.data;
  // Tolerate older backend instances during the rolling release of the 503 fix.
  if (data?.code === "AUTH_SERVICE_UNAVAILABLE" || /^Sequelize/.test(data?.err?.name || "")) return false;
  const config = error.config || error.response.config;
  if (!config || /\/(login|signin|pos_user_signin)(\?|$)/.test(config.url || "")) return false;
  const headers = config.headers || {};
  const token = headers["x-access-token"] || headers.Authorization || headers.authorization || headers.token;
  return typeof token === "string" && token.replace(/^Bearer\s+/i, "") === currentToken;
};

export const requestErrorMessage = (error, fallback) => {
  if (error?.response?.status >= 500 || /^Sequelize/.test(error?.response?.data?.err?.name || "")) {
    return "The service is temporarily unavailable. Please try again shortly.";
  }
  if (error?.code === "ECONNABORTED") return "The request took too long. Please try again.";
  if (!error?.response) return "Could not connect. Check your connection and try again.";
  return typeof error.response.data?.message === "string" ? error.response.data.message : fallback;
};
